// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.RentalManagerUserPropertyListV2WebApiHandler

import { frontEndRequestV2 } from '@zg-rentals/ts-client-fetch';
import type { RentalManagerEnvironment } from '@zg-rentals/rental-manager-env-base';

import type { RentalManagerUserPropertyListDto } from '../..';

interface ListParams {
  includeActive?: boolean;
  includeArchived?: boolean;
  includeAtRisk?: boolean;
  includeFeedClaimAndConvertUpdate?: boolean;
  includeFreeBonusListingsOnly?: boolean;
  includeFreeClaimedListingsOnly?: boolean;
  /**
   * @deprecated
   */
  includeFreeListingsOwnedByCustomer?: boolean;
  includeInactive?: boolean;
  includeListingCounts?: boolean;
  includeTours?: boolean;
  includeUnarchived?: boolean;
  includeUserManagementCompanyId?: boolean;
  limit?: number;
  offset?: number;
  searchText?: string;
  startKeyExclusive?: string;
}

export const RentalManagerUserPropertyListV2WebApiHandler_list_Path = '/api/web/v2/users/properties/list';

/**
 * List a user's properties
 */
export const RentalManagerUserPropertyListV2WebApiHandler_list = (
  getParams: ListParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<ListParams, never, RentalManagerUserPropertyListDto>({
    getParams: getParams,
    endpoint: RentalManagerUserPropertyListV2WebApiHandler_list_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};
